import { fetchWithHeaders } from "./fetchWithHeaders";

const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

export type NegotiationWidget = {
  negotiation_report_chart_id: number;
  negotiation_id: number;
  page_name: string;
  component_type: string;
  chart_vegajson: any;
  chart_description?: string | null;
  is_display: boolean;
};

export type NegotiationWidgetCreate = {
  negotiation_id: number;
  page_name: string;
  component_type: string;
  chart_vegajson: any;
  chart_description?: string;
  is_display?: boolean;
};

export type CustomTab = {
  id: number;
  negotiation_id: number;
  page_name: string;
};

export const WidgetsApi = {
  async listCustomTabs(negotiationId: number): Promise<CustomTab[]> {
    const resp = await fetchWithHeaders(
      `${API_BASE}api/v1/negotiation-packages/custom-tab?negotiation_id=${negotiationId}`,
      { method: "GET" }
    );
    if (!resp.ok) throw new Error(await resp.text());
    return resp.json();
  },

  async createCustomTab(negotiationId: number, pageName: string): Promise<CustomTab> {
    const resp = await fetchWithHeaders(`${API_BASE}api/v1/negotiation-packages/custom-tab`, {
      method: "POST",
      body: JSON.stringify({ negotiation_id: negotiationId, page_name: pageName }),
    });
    if (!resp.ok) throw new Error(await resp.text());
    return resp.json();
  },

  async deleteCustomTab(tabId: number): Promise<void> {
    const resp = await fetchWithHeaders(`${API_BASE}api/v1/negotiation-packages/custom-tab/${tabId}`, {
      method: "DELETE",
    });
    if (!resp.ok) throw new Error(await resp.text());
  },

  async listWidgets(negotiationId: number, pageName: string): Promise<NegotiationWidget[]> {
    const resp = await fetchWithHeaders(
      `${API_BASE}api/v1/negotiation-packages/widget?negotiation_id=${negotiationId}&page_name=${encodeURIComponent(
        pageName
      )}&is_display=true`,
      { method: "GET" }
    );
    if (!resp.ok) throw new Error(await resp.text());
    return resp.json();
  },

  async removeWidget(widgetId: number): Promise<void> {
    const resp = await fetchWithHeaders(`${API_BASE}api/v1/negotiation-packages/widget/${widgetId}`, {
      method: "PUT",
      body: JSON.stringify({ is_display: false }),
    });
    if (!resp.ok) throw new Error(await resp.text());
  },

  async createWidget(payload: NegotiationWidgetCreate): Promise<NegotiationWidget> {
    const resp = await fetchWithHeaders(`${API_BASE}api/v1/negotiation-packages/widget`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    if (!resp.ok) throw new Error(await resp.text());
    return resp.json();
  },
};
